import { ComponentLoaderProps } from "./ComponentLoaderProps";
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

const ComponentLoader = (props: ComponentLoaderProps): JSX.Element => {
    const { children, isLoading, lines } = props;

    return (
        isLoading ? <Skeleton count={lines} /> : <>{children}</>
    );
} 

ComponentLoader.defaultProps = {
    lines: 2
}

export default ComponentLoader;